let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("6fOjk")).then(() => parcelRequire('4N7bG'));